import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    let slidesPerView = parseInt(this.element.getAttribute('data-slidesPerView'));
    const spaceBetween = parseInt(this.element.getAttribute('data-spaceBetween'));

    const swiperElement = this.element.querySelector('.mySwiper')

    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      slidesPerView = 1.3;
    } else {
      slidesPerView = parseInt(this.element.getAttribute('data-slidesPerView')) + 0.8;
    }

    const nextEl = this.element.querySelector('.swiper-next');
    const prevEl = this.element.querySelector('.swiper-prev');

    var swiper = new window.Swiper(swiperElement, {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: isMobile,
      watchSlidesProgress: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });

    const fullySlidesVisible = isMobile ? 1 : parseInt(this.element.getAttribute('data-slidesPerView'));

    const updateSlideOpacity = () => {
      const start = swiper.activeIndex;
      const end = start + fullySlidesVisible;
      swiper.slides.forEach((slide, index) => {
        slide.style.opacity = (index >= start && index < end) ? '1' : '0.4';
      });
    };

    const updateArrows = () => {
      if (isMobile) return;
      prevEl.style.display = swiper.isBeginning ? 'none' : '';
      nextEl.style.display = swiper.isEnd ? 'none' : '';
    };

    updateArrows();
    updateSlideOpacity();
    swiper.on('slideChange', () => {
      updateArrows();
      updateSlideOpacity();
    });

    swiper.on("keyPress", (swiper, keyCode) => {
      switch (keyCode) {
        case 38:
          swiper.slidePrev();
          break;
        case 40:
          swiper.slideNext();
          break;
      }
    });
  }
}
